import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type VaultAppToastType = 'success' | 'error' | 'info' | 'warning';

export interface VaultAppToastEvent {
  type: VaultAppToastType;
  title: string;
  message: string;
  duration?: number;
}

/** Toasts globales del layout Vault (p. ej. exportación en auditoría). */
@Injectable({ providedIn: 'root' })
export class VaultAppToastService {
  private readonly toastSubject = new Subject<VaultAppToastEvent>();
  readonly toast$ = this.toastSubject.asObservable();

  show(event: VaultAppToastEvent): void {
    this.toastSubject.next(event);
  }
}
